/**
 * Given an error, parse out the type for tagging.
 */
export const getErrorType = (error: Error) =>
  error.name === 'GraphQLError' ? 'graphql' : 'browser';

/**
 * Given some error information, if we are in production lets capture
 * the details and log it to sentry
 */
export const captureError = (error: Error) => {
  if (
    process.env.NODE_ENV === 'production' &&
    window.Sentry &&
    !window.TEST_ENV
  ) {
    Sentry.withScope((scope) => {
      // Add tag for sentry searching. Currently, all errors reported to Sentry
      // are tagged with the "browser" type.
      scope.setTag('type', 'browser');

      // Return the eventid so we can associate it to feedback
      Sentry.captureException(error);
    });
  }
};

export const isGraphQLNotFoundError = (error?: Error) =>
  !!error && (error as any).code === 'NOT_FOUND';
